import { render, staticRenderFns } from "./EmployeeCertificates.vue?vue&type=template&id=6b8c7fbb&scoped=true"
import script from "./EmployeeCertificates.vue?vue&type=script&lang=js"
export * from "./EmployeeCertificates.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCertificates.vue?vue&type=style&index=0&id=6b8c7fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c7fbb",
  null
  
)

export default component.exports